const cdnUrl = 'https://puzzles.cdn.livingsecurity.com/ExamGuide/EntranceExam';

// Note: Strings should map to a translation key in './locales/en'
export default function getEntranceExamBriefData() {
  return {
    backgroundImage: 'https://puzzles.cdn.livingsecurity.com/CEO/EntranceExam/GameBG.jpg',
    files: [
      {
        nameKey: 'emoji-passphrase',
        clueKey: 'examine',
        src: `${cdnUrl}/EE_Puzzle5_Emoji_Passphrase_v3.jpg`,
        type: 'IMAGE',
      },
      {
        nameKey: 'bake-me-a-cake-poster',
        clueKey: 'examine',
        src: `${cdnUrl}/EE_Puzzle1_CakeSecurityPoster_v1.jpg`,
        type: 'IMAGE',
      },
      {
        nameKey: 'charity-website',
        clueKey: 'examine',
        src: `${cdnUrl}/EE_Puzzle3a_Charity_Website_v3.jpg`,
        type: 'IMAGE',
      },
      {
        nameKey: 'security-hygiene-calculator',
        clueKey: 'examine',
        src: `${cdnUrl}/EE_Puzzle4_Security_Hygiene_Calculator_v2.jpg`,
        type: 'IMAGE',
      },
      {
        nameKey: 'leaked-coffee-email',
        clueKey: 'examine',
        src: `${cdnUrl}/EE_Puzzle3b_Leaked_Coffee_Email_v1.jpg`,
        type: 'IMAGE',
      },
    ],
    puzzles: [
      {
        nameKey: 'puzzle-spotpatrol-brief',
        clueKey: 'examine',
        src: `${cdnUrl}/SpotPatrol.jpg`,
        url: 'https://SpotPatrol.livingsecurity.com',
        type: 'PUZZLE',
      },
      {
        nameKey: 'puzzle-generalbec-brief',
        clueKey: 'examine',
        src: `${cdnUrl}/GeneralBEC.jpg`,
        url: 'https://GeneralBEC.livingsecurity.com',
        type: 'PUZZLE',
      },
      {
        nameKey: 'puzzle-hygiene-brief',
        clueKey: 'examine',
        src: `${cdnUrl}/hygiene.jpg`,
        url: 'https://Hygiene.livingsecurity.com',
        type: 'PUZZLE',
      },
      {
        nameKey: 'puzzle-emojipass-brief',
        clueKey: 'examine',
        src: `${cdnUrl}/EmojiPass.jpg`,
        url: 'https://EmojiPass.livingsecurity.com',
        type: 'PUZZLE',
      },
    ],
  };
}
